/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { IconButton } from "@mui/material";
import { SVGIcons } from "cms/icons/svg-icons";

const LinkDisplay = (props) => {
    const link = props?.link;
    const onChange = props?.onChange;
    const onRemove = props?.onRemove;

    return (
        <Fragment>
            {link && link?.guid && (
                <div className='events-council-feed-link-display'>
                    <div className='events-council-feed-link-display-view'>
                        <div className='events-council-feed-link-display-content'>
                            <div className="events-council-feed-link-display-content-icon">
                                <SVGIcons.common.Link />
                            </div>
                            <div className="events-council-feed-link-display-content-info">
                                <div className="events-council-feed-link-display-content-info-title">
                                    {link?.text}
                                </div>
                                <div className="events-council-feed-link-display-content-info-url">
                                    {link?.url}
                                </div>
                            </div>
                            <div className='events-council-feed-link-display-content-actions'>
                                <div className='events-council-feed-link-action-change'>
                                    <IconButton onClick={onChange}>
                                        <SVGIcons.common.Edit />
                                    </IconButton>
                                </div>
                                <div className='events-council-feed-link-action-remove'>
                                    <IconButton onClick={onRemove}>
                                        <SVGIcons.common.Close />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

LinkDisplay.displayName = "LinkDisplay";
export { LinkDisplay };

